/*eslint-disable*/
import React from 'react';
//import '../../../assets/css/home/index.css';
import "../../../assets/css/common/AllCss.css";
import "../../../assets/css/common/Swiper.css";
import Swiper from "../../../assets/js/libs/swiper.min.js";	//轮播
import config from '../../../assets/js/conf/config.js';
import {request} from '../../../assets/js/libs/request.js';
import {lazyImg, setScrollTop} from '../../../assets/js/utils/util.js';		//图片懒加载	
import SearchComponent from '../../../components/search/search.js';
import {connect} from 'react-redux';
import rAction from '../../../rAction';
import { Toast } from 'antd-mobile';


class IndexComponent extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			aSwitch : [],
			publicCourses: null,
			zhibo: null,
			recom: [],
			Screen: false,
			phone: localStorage['phone']!== undefined?localStorage['phone']:'',
			BiaoQianJson: null
		};
		this.Screen = true;
		this.searchStyle = {display:"none"};
	}
    componentDidMount(){
		//console.log(global.scrollTop.index)
		
    	setScrollTop(global.scrollTop.index);
        this.getSwitch();
		
        window.addEventListener("scroll", this.isScren.bind(this),false);
        
        new Swiper(this.refs['swiper-container2'],{
		    slidesPerView :'auto'
		})
        localStorage.removeItem('outlineDetails');
    }
    componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		window.removeEventListener("scroll", this.isScren.bind(this));
		this.setState = (state, callback)=>{
			return;
		}
	}
    isScren(){
		//console.log(123)
    	if(this.Screen){
    		let isScreen = document.documentElement.scrollTop || document.body.scrollTop;
    		global.scrollTop.index = isScreen;
	    	if(isScreen>=100){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
    getSwitch(){
    	//let that = this;
    	//轮播图
    	request(config.baseUrl+'api/Study/S002', "post").then(res=>{
            if(res && res.code == 0){
            	this.setState({
					aSwitch: res.data.adPics
            	}, ()=>{
    				lazyImg();
    				new Swiper(this.refs['swiper-container'], {
				      	autoplay: {
				        	delay: 3000,
				        	disableOnInteraction: false
				      	},
				      	pagination: {
					        el: '.swiper-pagination',
					    }
                    })
    			})
            	this.setState({
					publicCourses: res.data.publicCourses
            	}, ()=>{
    				lazyImg();
    			})
            }
        });
        //正在直播
    	request(config.baseUrl+'api/Study/S009', "post").then(res=>{
            //console.log(res)
            if(res.code == 0 && res.data){
            	this.setState({
					zhibo: res.data
            	}, ()=>{
    				lazyImg();
    			})
            }
        });
        //标签
    	request(config.baseUrl+'api/Study/S019', "post").then(res=>{
			let Arr = [];
            if(res.code == 0 && res.data.length>0){
            	res.data.forEach((item,index) => {
            		Arr.push({});
            		request(config.baseUrl+'api/Study/S006', "post", {tagId: item.id}).then(res2=>{
            			if(res2.data.length>0){
            				res2.data.forEach(item2 => {
				            	if(item2.outlines.length>0){
				            		Arr[index] = item2;
				            	}
				            })
				            localStorage['Arr'] = JSON.stringify(Arr);
				            let Ary = [];
				            for(let i=0;i<=Arr.length;i++){
				            	//console.log(Arr[i])
				            	if(Arr[i] == undefined){
				            		break;
				            	}
				            	var arr = Object.keys(Arr[i]);
								
				            	if(arr.length != 0 && Arr[i].outlines.length >= 4){
				            		Ary.push(Arr[i]);
				            		break;
				            	}
				            }
				            this.setState({
				            	BiaoQianJson: Ary
				            })
            			}
			        });
            	})
            }
        });
        //消息数
//      request(config.baseUrl+'api/Study/S009', "post").then(res=>{
//          if(res && res.code == 0){
//          	this.setState({
//					zhibo: res.data
//          	}, ()=>{
//  				lazyImg();
//  			})
//          }
//      });
    }
    LeftIcon(path){
    	//console.log(this.props);
    	this.props.history.push(path);
    }
    searchClick(display){
    	//console.log(1,display)
    	this.setState(
    		this.searchStyle = display
    	)
    }
    pushPage(index){
    	//Toast.info("系统正在开发中，敬请期待！",1);
    	if(index == 1){
    		window.location.href='https://shop2717912.m.youzan.com/v2/showcase/homepage?alias=qqpmlqu0&sf=wx_sm&redirect_count=1&is_share=1&share_cmpt=native_wechat&from_uuid=31672aa9-e2ac-b311-af27-cea554b48c8f';
    	}else if(index == 2){
    		this.props.history.push('/notfind');
    		//window.location.href='https://shop2717912.m.youzan.com/v2/showcase/homepage?alias=qqpmlqu0&sf=wx_sm&redirect_count=1&is_share=1&share_cmpt=native_wechat&from_uuid=31672aa9-e2ac-b311-af27-cea554b48c8f';
    	}else if(index == 3){
    		window.location.href='https://shop2717912.m.youzan.com/v2/feature/1fs0ivcnh?sf=wx_sm&is_share=1&share_cmpt=native_wechat&from_uuid=31672aa9-e2ac-b311-af27-cea554b48c8f';
    	}else if(index == 4){
    		window.location.href='https://appn51pnzdd9102.h5.xiaoeknow.com/content_page/eyJ0eXBlIjo1LCJyZXNvdXJjZV90eXBlIjoiIiwicmVzb3VyY2VfaWQiOiIiLCJwcm9kdWN0X2lkIjoicV81ZTVlMDA3MmUyYzIxXzhHRW5lR3drIiwiYXBwX2lkIjoiYXBwTjUxcG56REQ5MTAyIn0?entry=2&entry_type=2001';
    	}
    	
    }

    render(){
        return(
            <div>
                <div className={this.state.Screen?'search-header search-header red-bg':'search-header search-header'}>
	                <div className={'search-wrap'} onClick={this.searchClick.bind(this,{display:"block"})}>
                        <div className={'search-icon'}></div>
                        <div className={'search-text'}>搜索</div>
                    </div>
                    <div className={'login-wrap'}>
                        <div className={'my'} onClick={this.pushPage.bind(this, '2')}>
                        	<span className={'mesSpan hide'}>10</span>
                        </div>
                    </div>
                </div>
                
                <div ref='swiper-container' className={"swiper-container"}>
				  <div className="swiper-wrapper">
				  	{
            			this.state.aSwitch.map((item,index) => {
            				return (
            					<div key={index} className="swiper-slide" onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item.Obj_ID)}>
            						<img src={item.Shp_Url?item.Shp_Url:require('../../../assets/images/home/index/banner_5.jpg')} alt={item.Shp_Site} />
            					</div>
            				)
            			})
                	}
				  </div>
				  <div ref='swiper-pagination' className={'swiper-pagination'}></div>
				</div>
				<div className={'quick-nav'}>
					<ul className={'item'} onClick={this.pushPage.bind(this, '1')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/common/nav1.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>商城</li>
                    </ul>
                    <ul className={'item'} onClick={this.pushPage.bind(this, '2')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/common/nav2.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>电子书</li>
                    </ul>
                    <ul className={'item'} onClick={this.pushPage.bind(this, '3')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/common/nav3.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>锦囊</li>
                    </ul>
                    <ul className={'item'} onClick={this.pushPage.bind(this, '4')}>
                        <li className={'item-img'}>
                        	<img src={require('../../../assets/images/common/nav4.png')} alt={'图片'} />
                        </li>
                        <li className={'item-text'}>在线坐诊</li>
                    </ul>
                </div>
                <div className={this.state.zhibo?'found':'hide'}>
                	<div className={'found-title-wrap'}>
                	{
                		this.state.zhibo?
                		<React.Fragment>
	                		<div className={'found-title zhibo'}>正在直播</div>
	                		<div className={'found-item0'} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+(this.state.zhibo!=null?this.state.zhibo.merchandiseId:''))}>
	                			<div className={'found-img0'}>
	                            	<img alt={this.state.zhibo!=null?this.state.zhibo.Ol_Name:''} data-echo={this.state.zhibo.Ol_Logo != ''?this.state.zhibo.Ol_Logo:require('../../../assets/images/home/index/banner_5.jpg')} />
	                            </div>
	                            <div className={'found-txt'}>
		                            <div className={'found-title0'}>{this.state.zhibo!=null?this.state.zhibo.Ol_Name:''}</div>
		                            <div className={"found-text0"}>{this.state.zhibo!=null?this.state.zhibo.Ol_Intro:''}</div>
									<div className={"found-text0 LiveTime"}>{this.state.zhibo!=null?this.state.zhibo.Ol_LiveTime:''}</div>
		                            <div className={"found-text-foot"}>
		                            	<div className={"found-text-foot-nub"}>{this.state.zhibo!=null?this.state.zhibo.Ol_LookCount:'0'}人次在线</div>
		                            	<div className={"found-text-foot-btn"}>进入直播</div>
		                            </div>
	                            </div>
	                        </div>
                        </React.Fragment>
                        :''
                	}
                	</div>
                </div>
                <div className={'found'}>
                    <div className={'found-title-wrap'}>
                		<div className={'found-title tuijian'}>课程推荐</div>
                        <div className={'found-itemN'}>
	                        {
	                			this.state.publicCourses!=null?
	                			this.state.publicCourses.map((item, index) => {
	                				return(
	                					<div className={'row'} key={index} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item.merchandiseId)}>
				                        	<div className={'found-row'}>
				                        		<div className={'found-title found-row1'}>
				                        			<div className={'titleN'}>
				                        				<div className={'found-title-photo'}>
					                        				<img src={item.TeacherPhoto != ''?item.TeacherPhoto:require('../../../assets/images/common/my1.png')} />
					                        			</div>
				                        				{item.Ol_Name}
				                        			</div>
				                        		</div>
				                        		<div className={"found-btn"}>
				                        			<img src={require('../../../assets/images/common/bfq.png')} />&nbsp;
				                        			播放
				                        		</div>
				                        	</div>
					                        <div className={'found-row found-row2'}>
				                        		<div className={'found-title'}>{item.Ol_Intro != ''?item.Ol_Intro:item.Ol_Name}</div>
				                        	</div>
			                        	</div>
	                				)
	                			})
								:''
	                		}
                        </div>
                	</div>
                </div>
                {
                	this.state.BiaoQianJson?
                	this.state.BiaoQianJson.map((item,index) => {
            			return (
                			<div className={'found'} key={index}>
			                	<div className={'found-title2'} style={{'marginBottom': '0'}}>
			                		{item.tagName}
			                		<span className={'found-title2-sp'}>全部</span>
			                	</div>
			                	<div className={'found-title-wrap'}>
			                		<div className={'found-classroom2 course'}>
			                		{
			                			item.outlines.map((item2,index2) => {
			                				return(
			                					<div className={'found-classroom-div indexbookNmae'} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item2.merchandiseId)} key={index2}>
						                			<div className={'found-classroom-img'}>
						                            	<img src={item2.Ol_Logo != ""?item2.Ol_Logo:require('../../../assets/images/video/pic_cover.png')} />
						                            	<span>课程</span>
						                            </div>
						                            <div className={'bookNmae indexbookNmae2'}>
						                            	<div className={'bookNmae-title'}>{item2.Ol_Name}</div>
						                            	<div>导师：{item2.TeacherName}</div>
						                            </div>
					                			</div>
			                				)
			                				
			                			})
			                		}
			                        </div>
			                	</div>
			                </div>
                		)
                	})
                	:<div className={"null"}>暂无课程内容!</div>
                }
                {
//              <div className={'found'} ref='swiper-container2'>
//              	<div className={'found-title2'}>榜单</div>
//              	<div className={'found-title-wrap2 swiper-wrapper'}>
//              		<div className={'found-list-row swiper-slide'}>
//              			<div className={'found-row-top'}> 
//              				<div className={'found-row-l1'}>
//              					<div className={'found-row-l1-div1'}>热门课程</div>
//              					<div className={'found-row-l1-div2'}>Top30</div>
//              				</div>
//              				<div className={'found-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot last'}>
//              				<span className={'span1'}>&nbsp;&nbsp;</span>
//              				<span>查看全部 ></span>
//              			</div>
//              		</div>
//              		<div className={'found-list-row swiper-slide'}>
//              			<div className={'found-row-top'}> 
//              				<div className={'found-row-l1'}>
//              					<div className={'found-row-l1-div1'}>热门课程</div>
//              					<div className={'found-row-l1-div2'}>Top30</div>
//              				</div>
//              				<div className={'found-img'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            </div>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot'}>
//              				<span className={'span1'}>1</span>
//              				<span>2+2补血技术</span>
//              			</div>
//              			<div className={'found-row-bot last'}>
//              				<span className={'span1'}>&nbsp;&nbsp;</span>
//              				<span>查看全部 ></span>
//              			</div>
//              		</div>
//              	</div>
//              </div>
//              	<div className={'found'}>
//	                	<div className={'found-title2'} style={{'marginBottom': '0'}}>
//	                		养猪小课堂
//	                		<span className={'found-title2-sp'}>全部</span>
//	                	</div>
//	                	<div className={'found-title-wrap'}>
//	                		<div className={'found-item0 found-classroom'}>
//	                			<div className={'found-img0'}>
//	                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//	                            	<span>课程</span>
//	                            </div>
//	                            <div className={'found-txt'}>
//		                            <div className={'found-title0'}>三元母猪繁殖性能提升集成技术技术技术技术</div>
//		                            <div className={"found-text0"}>朱中平-PSY应用研究院院长院长院长院长PSY应用研究院院长院长院长院长PSY应用研究院院长院长院长院长PSY应用研究院院长院长院长院长PSY应用研究院院长院长院长院长</div>
//		                            <div className={"found-text-foot"}>
//		                            	<div className={"found-text-foot-btn"}>播放</div>
//		                            </div>
//	                            </div>
//	                        </div>
//	                	</div>
//	                	<div className={'found-title-wrap'}>
//	                		<div className={'list-Title'}>专家精选</div>
//	                		<div className={'found-classroom2'}>
//	                			<div>
//		                			<div className={'found-classroom-img'}>
//		                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//		                            	<span>课程</span>
//		                            </div>
//		                            <div className={'bookNmae'}>《断奶母猪不发情》|余奎</div>
//	                			</div>
//	                			<div>
//		                			<div className={'found-classroom-img'}>
//		                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//		                            	<span>课程</span>
//		                            </div>
//		                            <div className={'bookNmae'}>《断奶母猪不发情》|余奎</div>
//	                			</div>
//	                			<div>
//		                			<div className={'found-classroom-img'}>
//		                            	<img src={require('../../../assets/images/home/index/banner_5.jpg')} />
//		                            	<span>课程</span>
//		                            </div>
//		                            <div className={'bookNmae'}>《断奶母猪不发情》|余奎</div>
//	                			</div>
//	                        </div>
//	                	</div>
//	                </div>
                }
                
                <div style={{height: 1.5+'rem'}}></div>
                <SearchComponent searchStyle={this.searchStyle} display={this.searchClick.bind(this)}></SearchComponent>
            </div>
        );
    }
}

export default connect((state)=>{
	return {
		state: state
	}
})(IndexComponent)
